export const DEFAULT_AGENDA_ITEM = {
  step: "groom_party",
  title: "Земање младоженец",
  description:
    "Собир кај младоженецот со забава и припрема за поаѓање накај невестата.",
  time: "12:00",
  address: "Домот на младоженецот",
};

export const createAgendaItem = (overrides = {}) => ({
  ...DEFAULT_AGENDA_ITEM,
  ...overrides,
});

export const AGENDA_STEP_SUGGESTIONS = [
  { value: "groom_party", label: "Земање младоженец" },
  { value: "bride_party", label: "Земање невеста" },
  { value: "ceremony", label: "Церемонија / Венчавка" },
  { value: "celebration", label: "Прослава" },
];
